module.exports = __webpack_public_path__ + "img/pry.bbc22e41.svg";